const columns = [
    {
        title: 'From',
        dataIndex: 'paymentFrom',
    },
    {
        title: 'To',
        dataIndex: 'paymentTo',
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
    },
    {
        title: 'Request Date',
        dataIndex: 'createdDate',
        sorter: true
    },
    {
        title: 'Action Date',
        dataIndex: 'actionDate',
        sorter: true
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    }
];

export default columns;